import { useTranslation } from 'react-i18next'

/**
 * Static reference list of Twitch chat commands handled by the bot,
 * localized to the current UI language.
 */
export function CommandsReference() {
  const { t, i18n } = useTranslation()
  const isFr = i18n.language === 'fr'

  return (
    <div className="border-t border-border mt-4 pt-4">
      <h3 className="text-sm font-semibold mb-2">{t('admin.live_commands_reference')}</h3>
      <ul className="text-sm text-muted-foreground space-y-1 font-mono">
        <li>
          <span className="text-foreground">!investigation</span> /{' '}
          <span className="text-foreground">!enquete</span> &mdash;{' '}
          {isFr ? "Afficher l'enquête et piste actives" : 'Show active investigation and lead'}
        </li>
        <li>
          <span className="text-foreground">!fact</span> /{' '}
          <span className="text-foreground">!fait</span> &mdash;{' '}
          {isFr ? 'Afficher le fait actif (sans args)' : 'Show the active fact (no args)'}
        </li>
        <li>
          <span className="text-foreground">!fact</span> /{' '}
          <span className="text-foreground">!fait</span>{' '}
          <span className="text-muted-foreground/70">&lt;url&gt; &lt;description&gt;</span> &mdash;{' '}
          {isFr ? 'Soumettre un fait pour la piste active' : 'Submit a fact for the active lead'}
        </li>
        <li>
          <span className="text-foreground">!fact_score</span> /{' '}
          <span className="text-foreground">!fait_score</span>{' '}
          <span className="text-muted-foreground/70">&lt;A-G&gt;</span> &mdash;{' '}
          {isFr
            ? 'Évaluer le fait actif (A = meilleure, G = pire)'
            : 'Rate the active fact (A = best, G = worst)'}
        </li>
        <li>
          <span className="text-foreground">!facts</span> /{' '}
          <span className="text-foreground">!faits</span> &mdash;{' '}
          {isFr ? 'Lister les faits de la piste active' : 'List facts for the active lead'}
        </li>
        <li>
          <span className="text-foreground">!help</span> /{' '}
          <span className="text-foreground">!aide</span> &mdash;{' '}
          {isFr ? 'Afficher les commandes' : 'Show commands'}
        </li>
      </ul>
    </div>
  )
}
